<template>
  <div class="footer__secondary-link-wrapper footer__secondary-link-copyright">
    <div v-html="resolvedCopyrightText" class="footer__secondary-link" :editable="false"></div>
  </div>
</template>

<script>
export default {
  name: 'FooterBottomLink',
  data() {
    return {};
  },
  computed: {
    resolvedCopyrightText: function() {
      if (!this.fields.CopyrightText || !this.fields.CopyrightText.value) {
        return '';
      }

      return this.fields.CopyrightText.value.replace('$year', new Date().getFullYear());
    },
  },
  props: {
    fields: {
      type: Object,
      default: () => ({
        CopyrightText: '&copy; Challenger $year',
      }),
    },
  },
};
</script>
<style lang="scss" scoped></style>
